import { render, staticRenderFns } from "./bannersEdit.vue?vue&type=template&id=45e1016a&scoped=true&"
import script from "./bannersEdit.vue?vue&type=script&lang=js&"
export * from "./bannersEdit.vue?vue&type=script&lang=js&"
import style0 from "./bannersEdit.vue?vue&type=style&index=0&id=45e1016a&prod&scoped=true&lang=css&"
import style1 from "./bannersEdit.vue?vue&type=style&index=1&id=45e1016a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1016a",
  null
  
)

export default component.exports